import React, { useEffect } from 'react'
import { register } from '../actions'

export default function DirectRegisterPage() {
  useEffect(() => {
    register()()
  }, [])

  return <></>
}
